import { keys, omit, pick, isEmpty } from 'lodash';

import {
  removeEmpty,
  stringToUpperCase,
  formatMobileNumber,
  jsUcFirst,
} from 'modules/common/utils';

import { dayOptions, INIT_FORM } from './constants';

export const transformBranch = (data) => {
  let args;
  const attr = data?.attributes;

  try {
    args = {
      ...attr,
      id: +data?.id,
      address: {
        pinned_address: attr?.pinned_address,
        geoloc: attr?.geoloc,
        address_details: attr?.address_details,
      },
      operation_time: {
        start: attr?.opening_time
          ? {
              value: stringToUpperCase(attr?.opening_time),
              label: stringToUpperCase(attr?.opening_time),
            }
          : '',
        end: attr?.closing_time
          ? {
              value: stringToUpperCase(attr?.closing_time),
              label: stringToUpperCase(attr?.closing_time),
            }
          : '',
      },
      operation_days: attr?.operation_days?.map((x) => ({
        value: x,
        label: x,
      })),
      scheduled_days: attr?.scheduled_days?.map((x) => ({
        value: x,
        label: x,
      })),
      business_name: jsUcFirst(attr?.business_name, ''),
      store_operations: Object.entries(attr?.store_operations)
        ?.filter((item) => item?.[1])
        ?.map((item) => ({
          operation_day: {
            label: item?.[0],
            value: item?.[0],
          },
          operation_time: item?.[1]?.map((subItem) => ({
            start: {
              label:
                subItem?.opening === '11:59 pm' ? '12:00 am' : subItem?.opening,
              value:
                subItem?.opening === '11:59 pm' ? '12:00 am' : subItem?.opening,
            },
            end: {
              label:
                subItem?.closing === '11:59 pm' ? '12:00 am' : subItem?.closing,
              value:
                subItem?.closing === '11:59 pm' ? '12:00 am' : subItem?.closing,
            },
          })),
        })),
    };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err, ' here');
  }

  const x = { ...pick(args, keys(INIT_FORM)) };

  return x;
};

export const transformPayload = (data, isCreate) => {
  const {
    is_open,
    branch_users,
    operation_days,
    scheduled_days,
    operation_time,
    mobile_number,
    delivery_methods,
    delivery_type,
    delivery_couriers,
    hour_slots,
    store_operations,
    payment_methods,
  } = data;

  const isPickUp = +delivery_methods?.includes('PICK_UP');
  const inHouse = delivery_methods?.filter((x) => x === 'IN_HOUSE');

  const dispatchPaymentMethods = () => {
    let arr = payment_methods;

    if (data?.payment_channels?.length > 0) {
      arr = [...arr, 'PAYMENT_GATEWAY'];
    }

    return [...new Set(arr)]?.filter((item) => item !== 'OVER_THE_COUNTER');
  };

  const args = {
    ...omit(data, ['address', 'operation_time', 'delivery_methods']),
    ...data?.address,
    operation_days: operation_days ? operation_days?.map((x) => x?.value) : '',
    hour_slots: hour_slots ? +hour_slots : 0,
    opening_time: operation_time?.start
      ? operation_time?.start?.value.toLowerCase()
      : '',
    closing_time: operation_time?.end
      ? operation_time?.end?.value.toLowerCase()
      : '',
    mobile_number: formatMobileNumber(mobile_number),
    is_open: +is_open,

    has_pickup_options: isCreate === 'CREATE' ? isPickUp : undefined,
    delivery_type: delivery_type?.value,
    delivery_couriers: [...inHouse, ...delivery_couriers],
    branch_users: isEmpty(removeEmpty(branch_users)) ? '' : [branch_users],
    scheduled_days: Array.isArray(scheduled_days)
      ? scheduled_days?.map((x) => x?.value)
      : [],
    payment_methods: dispatchPaymentMethods(),
    store_operations: dayOptions?.reduce((acc, item) => {
      const v = store_operations?.find(
        (subItem) => subItem?.operation_day?.value === item?.value
      );

      return {
        ...acc,
        [item?.value]:
          v?.operation_time?.length > 0 && v?.operation_time
            ? v?.operation_time?.map((subItem) => ({
                opening: subItem?.start?.value,
                closing:
                  subItem?.end?.value === '12:00 am'
                    ? '11:59 pm'
                    : subItem?.end?.value,
              }))
            : null,
      };
    }, {}),
  };

  return args;
};

export const transformPreference = (list) => {
  const args = list.map((item) => ({
    label: item?.label || item?.name,
    value: item?.value || item?.id,
  }));
  return args;
};
